import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

const useTariffValuesSelect = () => {
  const [tariffValues, setTariffValues] = useState([]);

  const data = useSelector((state) => state.rsoImportStore.data);

  const changeTariffValues = useCallback(
    (columnIndex) => {
      const uniqueValues = [
        ...new Set(
          data.map((row) => Object.values(row)[columnIndex]).filter(Boolean)
        ),
      ];

      const result = Array.from(uniqueValues, (item) => ({
        id: item,
        value: item,
        content: item,
        search: item,
      }));

      setTariffValues(result);
    },
    [data]
  );

  return { tariffValues, changeTariffValues };
};

export default useTariffValuesSelect;
